module.exports = __webpack_public_path__ + "static/media/19-iveco.50f4b12b.jpg";